import script from './component-lib.esm32.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    staticClass: "icon-ko-fi",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Ko-Fi'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M31.841 11.931c-1.031-5.447-6.479-6.124-6.479-6.124h-24.399c-0.805 0-0.905 1.064-0.905 1.064s-0.109 9.765-0.029 15.763c0.219 3.232 3.448 3.563 3.448 3.563s11.023-0.031 15.955-0.065c3.251-0.568 3.577-3.421 3.544-4.979 5.803 0.32 9.896-3.775 8.865-9.221zM17.092 16.612c-1.661 1.937-5.348 5.301-5.348 5.301s-0.161 0.159-0.413 0.031c-0.101-0.076-0.144-0.12-0.144-0.12-0.591-0.588-4.491-4.065-5.379-5.272-0.945-1.287-1.388-3.6-0.121-4.947 1.268-1.347 4.007-1.448 5.817 0.543 0 0 2.087-2.376 4.624-1.284 2.539 1.093 2.443 4.015 0.964 5.748zM25.323 17.249c-1.237 0.155-2.243 0.037-2.243 0.037v-7.575h2.36s2.628 0.735 2.628 3.517c0 2.551-1.313 3.556-2.745 4.020z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var KoFiIcon = __vue_component__;
export { KoFiIcon as default };